import { hooks } from "./hookactions"
export let SVLNewServiceStep1 = { hooks }
